function NotFoundPage() {
  return (
    <div className="checkout-container">
      <div className="checkout-header">
        <a href="https://openhosst.com" className="checkout-logo">
          <div className="logo-icon">OH</div>
          OpenHosst
        </a>
      </div>

      <div className="checkout-card">
        <div className="card-content">
          <div className="error-container">
            <div className="error-icon">404</div>
            <h1 className="error-title">Page Not Found</h1>
            <p className="error-message">
              The page you're looking for doesn't exist or has been moved.
            </p>
            <a href="https://openhosst.com" className="btn btn-primary">
              Return to OpenHosst
            </a>
          </div>
        </div>
      </div>

      <div className="checkout-footer">
        <div className="footer-links">
          <a href="https://openhosst.com/terms" className="footer-link">Terms</a>
          <a href="https://openhosst.com/privacy" className="footer-link">Privacy</a>
          <a href="https://openhosst.com/support" className="footer-link">Support</a>
        </div>
        <p className="footer-text">© 2025 OpenHosst. All rights reserved.</p>
      </div>
    </div>
  );
}

export default NotFoundPage;
